export const preventReadonly = {
    methods: {
        removeReadonly() {
            document.getElementById('no-paste').removeAttribute('readonly');
            // document.querySelectorAll('.preventReadOnly').removeAttribute('readonly');
        },
        isNumber(event) {
            // prevent user to enter non-numeric value
            if (event.keyCode < 48 || event.keyCode > 57) {
              event.returnValue = false;
            }
        },
    }
};